// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { ReactNativeManualDevicePlugin } from "./ReactNativeManualDevicePlugin";
export { ReactNativeManualDevicePlugin };
//# sourceMappingURL=manualIndex.js.map